/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_BInputs */

const en_event_b = /** @type {(inputs: Event_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event B`)
};

const fr_event_b = /** @type {(inputs: Event_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événement B`)
};

const de_event_b = /** @type {(inputs: Event_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltung B`)
};

const it_event_b = /** @type {(inputs: Event_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento B`)
};

const ru_event_b = /** @type {(inputs: Event_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Событие B`)
};

const es_event_b = /** @type {(inputs: Event_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento B`)
};

const zh_cn2_event_b = /** @type {(inputs: Event_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件 B`)
};

const ja_event_b = /** @type {(inputs: Event_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントB`)
};

const hi_event_b = /** @type {(inputs: Event_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटना बी`)
};

const pt_pt2_event_b = /** @type {(inputs: Event_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento B`)
};

/**
* | output |
* | --- |
* | "Event B" |
*
* @param {Event_BInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_b = /** @type {((inputs?: Event_BInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_BInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_b(inputs)
	if (locale === "de") return de_event_b(inputs)
	if (locale === "it") return it_event_b(inputs)
	if (locale === "ru") return ru_event_b(inputs)
	if (locale === "es") return es_event_b(inputs)
	if (locale === "zh-CN") return zh_cn2_event_b(inputs)
	if (locale === "ja") return ja_event_b(inputs)
	if (locale === "hi") return hi_event_b(inputs)
	if (locale === "pt-PT") return pt_pt2_event_b(inputs)
	return en_event_b(inputs)
});